import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import '../styles/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    submitting: false,
    error: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormStatus({ submitting: true, submitted: false, error: false });

    emailjs.sendForm(
      'service_dg3emyl',
      'template_a9o5yjl',
      e.target,
      '2fWmcAxvuMq7zccoK'
    )
      .then((result) => {
        console.log('✅ Email sent successfully:', result.text);
        setFormStatus({ submitted: true, submitting: false, error: false });
        setFormData({ name: '', email: '', phone: '', message: '' });
      })
      .catch((error) => {
        console.error('❌ Email send failed:', error);
        setFormStatus({ submitted: false, submitting: false, error: true });
      });
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/919049610819', '_blank');
  };

  return (
    <div className="contact">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Get In Touch</h1>
          <p>Let's Build Something Amazing Together</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="form-section">
              <h2>Send Us a Message</h2>
              <p className="form-description">
                Have a project in mind? Fill out the form below and our team will get back to you shortly.
              </p>
              
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="from_name">Full Name *</label>
                  <input
                    type="text"
                    id="from_name"
                    name="from_name"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    placeholder="Enter your full name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="from_email">Email Address *</label>
                  <input
                    type="email"
                    id="from_email"
                    name="from_email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    placeholder="your.email@example.com"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    placeholder="+91 XXXXX XXXXX"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    placeholder="Tell us about your project..."
                    rows="5"
                    required
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={formStatus.submitting}
                >
                  {formStatus.submitting ? 'Sending...' : 'Send Message'}
                </button>

                {formStatus.submitted && (
                  <div className="form-success">
                    ✅ Thank you! Your message has been sent successfully.
                  </div>
                )}
                
                {formStatus.error && (
                  <div className="form-error">
                    ❌ Failed to send. Please email directly: sksubup@gmail.com
                  </div>
                )}
              </form>
            </div>

            {/* Contact Information */}
            <div className="info-section">
              <h2>Contact Information</h2>
              <p className="info-description">
                Reach out to us through any of these channels
              </p>

              <div className="contact-info-grid">
                {/* Address Card */}
                <div className="info-card">
                  <div className="info-card-header address-header">
                    <div className="info-icon">📍</div>
                    <h3>Our Office</h3>
                  </div>
                  <div className="info-card-body">
                    <p>D-001, Periyar Building</p>
                    <p>Babhola Naka, Opp. D'mart</p>
                    <p>Vasai (West), Dist. Palghar</p>
                    <p>Maharashtra - 401 202</p>
                  </div>
                </div>

                {/* Phone Card */}
                <div className="info-card">
                  <div className="info-card-header phone-header">
                    <div className="info-icon">📞</div>
                    <h3>Call Us</h3>
                  </div>
                  <div className="info-card-body">
                    <p className="contact-detail">+91 9049610819</p>
                    <a href="tel:+919049610819" className="action-link">Call Now →</a>
                  </div>
                </div>

                {/* Email Card */}
                <div className="info-card">
                  <div className="info-card-header email-header">
                    <div className="info-icon">✉️</div>
                    <h3>Email Us</h3>
                  </div>
                  <div className="info-card-body">
                    <p className="contact-detail">sksubup@gmail.com</p>
                    <a href="mailto:sksubup@gmail.com" className="action-link">Send Email →</a>
                  </div>
                </div>

                {/* WhatsApp Card */}
                <div className="info-card whatsapp-special">
                  <div className="info-card-header whatsapp-header">
                    <div className="info-icon">💬</div>
                    <h3>WhatsApp</h3>
                  </div>
                  <div className="info-card-body">
                    <p>Chat with us instantly for quick responses</p>
                    <button onClick={handleWhatsApp} className="whatsapp-action-btn">
                      Start Chat on WhatsApp
                    </button>
                  </div>
                </div>
              </div>

              {/* Social Media */}
              <div className="social-card">
                <h3>Connect With Us</h3>
                <div className="social-links">
                  <a href="#" className="social-link facebook" aria-label="Facebook">
                    <span>f</span>
                  </a>
                  <a href="#" className="social-link twitter" aria-label="Twitter">
                    <span>𝕏</span>
                  </a>
                  <a href="#" className="social-link instagram" aria-label="Instagram">
                    <span>📷</span>
                  </a>
                  <a href="#" className="social-link linkedin" aria-label="LinkedIn">
                    <span>in</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Map Section */}
          <div className="map-section">
            <h2>Visit Our Office</h2>
            <p className="map-description">We're located in Vasai West, Maharashtra. Drop by for a consultation!</p>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120483.57634733183!2d72.74664477346255!3d19.36190037726455!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b8d924eae623%3A0x6398ec703b25a325!2sVasai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1635784567890!5m2!1sen!2sin"
                width="100%"
                height="450"
                style={{ border: 0, borderRadius: '15px' }}
                allowFullScreen=""
                loading="lazy"
                title="Office Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
